export enum TasksRefreshMode {
    auto = 0,
    manual
}